/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import clsx from 'clsx'
type Props = {
  id: string
  label: string
  placeholder?: string
  options?: any[]
  touched?: any
  errors?: any
  props?: any
}

const SelectBoxWithLabel: React.FC<Props> = ({
  id,
  label,
  placeholder,
  options,
  touched,
  errors,
  props,
}) => {
  return options ? (
    <>
      <div className='fv-row mb-8'>
        <label className='form-label fw-bolder text-dark fs-6'>{label}</label>
        <select
          id={id}
          placeholder={placeholder}
          autoComplete='off'
          {...props}
          className={clsx(
            'form-control bg-transparent',
            {
              'is-invalid': touched && errors,
            },
            {
              'is-valid': touched && !errors,
            }
          )}
        >
          <option></option>
          {options.map((x, i) => (
            <option key={id.toString() + i} value={x.key}>
              {x.value}
            </option>
          ))}
        </select>
        {touched && errors && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{errors}</span>
            </div>
          </div>
        )}
      </div>
    </>
  ) : (
    <></>
  )
  // <div className='fv-row mb-8'>
  //   <label className='form-label fw-bolder text-dark fs-6'>{label}</label>
  //   <input
  //     placeholder={placeholder}
  //     type='text'
  //     autoComplete='off'
  //     {...props}
  //     className={clsx(
  //       'form-control bg-transparent',
  //       {
  //         'is-invalid': touched && errors,
  //       },
  //       {
  //         'is-valid': touched && !errors,
  //       }
  //     )}
  //     value={value}
  //   />
  //   {touched && errors && (
  //     <div className='fv-plugins-message-container'>
  //       <div className='fv-help-block'>
  //         <span role='alert'>{errors}</span>
  //       </div>
  //     </div>
  //   )}
  // </div>
}

export {SelectBoxWithLabel}
